module.exports = __webpack_public_path__ + "static/appstore-552b254d5e8f6726fb40819992edebda.png";